import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

export interface ClientUsersState {
  activeClientUserId: string | null;
}

const initialState: ClientUsersState = {
  activeClientUserId: null,
};

const clientUsersSlice = createSlice({
  name: 'clientUsers',
  initialState,
  reducers: {
    setActiveClientUserId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeClientUserId = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveClientUserId = (state: RootState) => state.clientUsers.activeClientUserId;

export const { setActiveClientUserId } = clientUsersSlice.actions;

const clientUsersReducer = clientUsersSlice.reducer;

export default clientUsersReducer;
